import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private apiUrl = environment.apiURL + 'reports/orders-stages';
  private apiUrlEvolution = environment.apiURL + 'reports/orders-evolution';
  private apiUrlEvolutionCampaign =
    environment.apiURL + 'reports/orders-evolution-campaigns';
  private apiUrlEvolutionCampaignStock =
    environment.apiURL + 'reports/orders-evolution-campaign-stocks';
    private apiUrlEvolutionOrdersCampaignStock = 
    environment.apiURL + 'reports/orders-campaign-stocks';
  private apiUrlEvolutionOrdersCampaign =
    environment.apiURL + 'reports/orders-campaigns';
    private apiUrlEvolutionMatrixBrand =
    environment.apiURL + 'reports/campaign-stocks-matrix/brands';
     private apiUrlEvolutionMatrixModel =
    environment.apiURL + 'reports/campaign-stocks-matrix/models';
  private apiUrlExport =
    environment.apiURL + 'reports/export-evolution-campaign';
  private apiUrlNotDeliveredTokens =
    environment.apiURL + 'orders/not-delivered/tokens';
  private apiUrlNotDeliveredTokensRefresh =
    environment.apiURL + 'orders/not-delivered/tokens/refresh';

  constructor(private http: HttpClient) { }

  getData(
    /* pageNumber: number = 1,
    pageSize: number = 10, */
    params: any = {}
  ): Observable<any> {
    var url = `${this.apiUrl}`;
    return this.http.get(url, {
      params: {
        /* page: pageNumber.toString(),
        pageSize: pageSize.toString(), */
        ...params,
      },
    });
  }

  getDataEvolution(
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {}
  ): Observable<any> {
    var url = `${this.apiUrlEvolution}`;
    return this.http.get(url, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        ...params,
      },
    });
  }
  getDataEvolutionCampaign(
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {}
  ): Observable<any> {
    var url = `${this.apiUrlEvolutionCampaign}`;
    return this.http.get(url, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        ...params,
      },
    });
  }
getDataEvolutionMatrixBrand(
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {}
  ): Observable<any> {
    var url = `${this.apiUrlEvolutionMatrixBrand}`;
    return this.http.get(url, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        ...params,
      },
    });
  }
  getDataEvolutionMatrixModel(
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {}
  ): Observable<any> {
    var url = `${this.apiUrlEvolutionMatrixModel}`;
    return this.http.get(url, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        ...params,
      },
    });
  }

  getDataEvolutionCampaignStock(
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {}
  ): Observable<any> {
    var url = `${this.apiUrlEvolutionCampaignStock}`;
    return this.http.get(url, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        ...params,
      },
    });
  }

  getDataEvolutionOrdersCampaignStock(
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {},
    reference: string
  ): Observable<any> {
    var url = `${this.apiUrlEvolutionOrdersCampaignStock}`;
    return this.http.get(url, {
      params: {
        reference: reference,
        ...params,
      },
    });
  }

  getDataEvolutionOrdersCampaign(
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {},
    reference: string
  ): Observable<any> {
    var url = `${this.apiUrlEvolutionOrdersCampaign}`;
  //var url = `${this.apiUrlEvolutionCampaignStock}`; 
   return this.http.get(url, {
      params: {
        reference: reference,
        ...params,
      },
    });
  }

  exportData(params: any = {}): Observable<any> {
    return this.http.get(`${this.apiUrlExport}`, {
      params: params,
    });
  }

  getNotDeliveredTokens(): Observable<any> {
    return this.http.get(this.apiUrlNotDeliveredTokens);
  }

  createNotDeliveredToken(supplierReference: string): Observable<any> {
    return this.http.post(this.apiUrlNotDeliveredTokens, {
      supplier_id: supplierReference,
    });
  }

  refreshNotDeliveredToken(supplierReference: string): Observable<any> {
    return this.http.post(this.apiUrlNotDeliveredTokensRefresh, {
      supplier_id: supplierReference,
    });
  }
}
